import { INormalizedObjects } from './store/normalizedObjects'

declare global {
    interface Array<T> {
        firstOrDefault(predicate?: (e: T) => boolean): T | undefined;
    }

    interface String {
        cAppend(add: any, value?: string): string;
        cFormatNewLines(): string;
    }

    interface INormalizedObjects<T> {
        all(): T[];
    }
}

if (!Array.prototype.find) {
    // eslint-disable-next-line no-extend-native
    Array.prototype.firstOrDefault = function <T>(predicate?: (e: T) => boolean): T | undefined {
        for (const e of this) {
            if (!predicate || predicate(e)) {
                return e;
            }
        }

        return undefined;
    }
} else {
    // eslint-disable-next-line no-extend-native
    Array.prototype.firstOrDefault = function <T>(predicate?: (e: T) => boolean): T | undefined {
        if (!predicate) {
            return this.length ? this[0] : undefined;
        }

        return this.find(predicate);
    }
}

// eslint-disable-next-line no-extend-native
String.prototype.cAppend = function (add: any, value?: string) {
    return add ? `${this} ${value || add}` : this as string;
}

// eslint-disable-next-line no-extend-native
String.prototype.cFormatNewLines = function () {
    return this.replace(/(?:\r\n|\r|\n)/g, '<br />');
}

function all<T>(collection: INormalizedObjects<T>) {
    return collection.allIds.map(id => collection.byId[id]);
}

const participantStatusMap: { [key: string]: string } = {
    'ACCEPTED': 'Deltager',
    'TENTATIVE': 'Deltager måske',
    'NEEDS-ACTION': 'Inviteret',
    'DECLINED': 'Frameldt',
    'ALLE':''
};

export { all, participantStatusMap };